'use client';

import * as Tabs from '@fe-common-ui/Tabs';
import { useContext } from 'react';
import { PopTopicTab, PopTopicTabNames } from '@fe-news/constants/pop-topic/type';
import { styled } from '@linaria/react';
import { PopTopicContext } from '@fe-news/context/pop-topic-provider';

const HotIssueTab = styled.span<{ active?: boolean }>`
  color: ${({ active }) => (active ? '#e03f19' : '#515c69')};
  font-weight: ${({ active }) => (active ? '500' : 'normal')};
`;

type SwitchProps = {
  tab: PopTopicTab;
  onClickTab: (tab: PopTopicTab) => void;
};

const Switch: React.FC<SwitchProps> = ({ tab, onClickTab }) => {
  const { setKeyword } = useContext(PopTopicContext);

  const onClick = (tab: PopTopicTab) => {
    onClickTab(tab);
    setKeyword && setKeyword('');
  };

  return (
    <Tabs.Switch active={tab} onClick={onClickTab}>
      <HotIssueTab active={tab === PopTopicTab.PopTopic} onClick={() => onClick(PopTopicTab.PopTopic)}>
        {PopTopicTabNames.PopTopic}
      </HotIssueTab>
      <HotIssueTab active={tab === PopTopicTab.Timeline} onClick={() => onClick(PopTopicTab.Timeline)}>
        {PopTopicTabNames.Timeline}
      </HotIssueTab>
    </Tabs.Switch>
  );
};

export default Switch;
